Alpine.directive("total", (_, { expression }, {evaluateLater, evaluate}) => {
    let data = evaluate('$data');
    evaluateLater(expression)(total => {
        data.total = total;
    });
});
